import { combineReducers } from 'redux';
import landing from './landing.reducer';
import aMeasurement from './aMeasurement.reducer';
import tft from './tft.reducer';
import dataUpdate from './dataUpdate.reducer';

const reducer = combineReducers({
	landing,
    aMeasurement,
    tft,
    dataUpdate
});

export default reducer;
